import './styles.scss';
import React from "react";

/* types, constants, utils */
import * as Constants from "../../../../../constants";

/* bootstrap */
import {Button} from "react-bootstrap";

/* components */
import ViewerCard from "../../../viewer-card";
import {IViewerState} from "../../../../../types/redux/viewer";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../redux";
import useRecordListItemSelect from "../../../hooks/useInsertDBFields";

interface IProps {
  setNumOfRecords(value:number): void;
}

const ViewerDuplicatesList = (props: IProps):JSX.Element => {
  /* redux */
  const viewerState: IViewerState = useSelector<RootState, IViewerState>(state => state.viewer);

  /* hooks*/
  const handleSelectRecord = useRecordListItemSelect().handleSelectRecord;

  const card = (result: any, index: number):JSX.Element => {
    return <Button
      key={`dc-${index}`}
      className={'viewer-card-wrapper mb-2 text-dark p-0 bg-transparent text-start w-100'}
      active={viewerState.initialRecord && viewerState.viewerRecord && (viewerState.initialRecord.id === result.id) && (viewerState.viewerRecord.id === result.id)}
      onClick={()=>handleSelectRecord(result)}
    >
      <ViewerCard
        index={index}
        record={result}
        page={1}
        resultsPerPage={Constants.VW_NUM_ROWS}
      />
    </Button>
  }

  return (
    <div className={'viewer-more-like-list overflow-scroll pt-2'}>
      <div className={'cards d-flex flex-column pb-2'} >

        {/* initial card */}
        {card(viewerState.initialRecord, -1)}

        {viewerState.possibleDuplicates.map((result: any, index: number) => {
          return card(result, index)
        })}
      </div>
    </div>
  )
}
export default ViewerDuplicatesList;
